import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import { Provider } from "react-redux"
import store from "./store/store";
import { ToastContainer } from "react-toastify";
import { FirebaseProvider } from "./firebase/firebase";

ReactDOM.render(
  <BrowserRouter>
    <FirebaseProvider>
    <Provider store={store}>
    
      <ToastContainer />
      <App />
      <ScrollToTop />
    </Provider>
    </FirebaseProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
